// To use your own photos: replace any `image` value below with your Cloudinary link (e.g. "https://res.cloudinary.com/...jpg").
const LIGHT = { id: "light", name: "Sheer & Nordic Walnut", swatch: ["#EDE6DA", "#A57449"] };
const DARK = { id: "dark", name: "Dark Grey & Mountain Oak Dark", swatch: ["#47464A", "#5B3F2C"] };
const FEATURES = ["Moisture Resistant", "18mm Thicker Board"];

export const CATEGORIES = [
  { id: "all", label: "All Pieces" },
  { id: "book-racks", label: "Book Racks" },
  { id: "tv-stands", label: "TV Stands" },
  { id: "coffee-tables", label: "Coffee Tables" },
  { id: "workstations", label: "Workstations" },
  { id: "side-tables", label: "Side Tables" },
  { id: "shoe-storage", label: "Shoe Storage" },
  { id: "wall-shelves", label: "Wall Shelves" },
];

const make = (slug, name, type, category, size, tagline, description, lightImg, darkImg) => ({
  slug, name, type, category, size, tagline, description, price: 49000, features: FEATURES,
  finishes: [
    { ...LIGHT, image: lightImg || `/products/${slug}-0.jpg` },
    { ...DARK, image: darkImg || `/products/${slug}-1.jpg` },
  ],
});

export const PRODUCTS = [
  make("spine", "Spine", "Book Rack", "book-racks", "972 × 1800 × 250 mm",
    "The backbone of the living room.",
    "Spine Book Rack, serving not just as furniture but as the literal and metaphorical backbone of the entire living space. Like a masterfully engineered column, its interlocking panels climb toward the ceiling, holding a curated lifetime of memories, art, and literature."),
  make("monolith", "Monolith", "Book Rack", "book-racks", "972 × 1500 × 220 mm",
    "Architecture you can live with.",
    "Rising with bold, architectural lines, its dual-column silhouette serves as a striking room divider. The open, backless design allows sunlight to stream through effortlessly, framing your favourite classics, curated art pieces and collected treasures."),
  make("nesta", "Nesta", "TV Stand", "tv-stands", "1500 × 418 × 400 mm",
    "Effortless balance for the screen wall.",
    "The Nesta TV Stand brings effortless balance to modern spaces. A warm wood top paired with a clean geometric frame, its open-shelf design neatly organises your soundbar, consoles and decor."),
  make("lumi", "Lumi", "TV Stand", "tv-stands", "1000 × 418 × 400 mm",
    "Organic warmth, minimal form.",
    "The Lumi TV Stand blends organic warmth with minimalist design. A thick natural wood surface and an open two-tier frame offer clean storage for media consoles and curated decor."),
  make("arbor", "Arbor", "Workstation", "workstations", "1200 × 600 × 750 mm",
    "A calmer place to focus.",
    "Bring the calming essence of nature into your workspace. This Scandinavian-inspired desk pairs a warm oak-grain frame with a clean desktop, with integrated dual-level side shelves that keep books and essentials within arm's reach."),
  make("dallas", "Dallas D-15", "Coffee Table", "coffee-tables", "1000 × 450 × 750 mm",
    "Not just a surface — a gathering point.",
    "The morning light shifts across the room, catching the subtle, organic grain of the wood. Whether anchoring an intimate conversation over espresso or organising your evening inspiration, its minimalist frame adapts effortlessly to your life."),
  make("alandra", "Alandra", "Coffee Table", "coffee-tables", "1000 × 450 × 750 mm",
    "The anchor every home needs.",
    "Clean, minimalist lines and a warm natural wood finish balance modern structure with cosy texture. A generous top for your morning routine, and a spacious open lower shelf for current reads, magazines or a folded throw."),
  make("lineo", "Lineo", "Shoe Cupboard", "shoe-storage", "936 × 198 × 397 mm",
    "A quiet entryway, finally.",
    "A warm wood-look frame with sleek doors to clear entryway clutter. Behind its minimalist exterior, five spacious shelves hide everything from heels to sneakers, while the flat top is a landing spot for keys and decor."),
  make("nook", "Nook", "Side Table", "side-tables", "300 × 700 × 400 mm",
    "Everything, right at your fingertips.",
    "A slim C-shaped silhouette that slides seamlessly over sofa arms. Designed to save floor space without sacrificing style — the companion for morning coffee, evening reads and remote work."),
  make("ona", "Ona", "Cube Shelves", "wall-shelves", "400 × 400 × 100 mm",
    "Turn a wall into a gallery.",
    "Beautifully grained cubes that break away from traditional design to create a rhythmic, floating display — framing cascading vines, minimalist ceramics and your favourite memories."),
  make("nexus", "Nexus", "Wall Shelves", "wall-shelves", "300 × 595 × 118 mm",
    "Where clean lines meet warm grain.",
    "Nexus means a central link. This sculptural piece interlocks a bold, continuous geometric frame with a rich wood spine — a dialogue between architectural lines and grounding natural texture."),
];

export const formatINR = (n) => `₹${Number(n).toLocaleString("en-IN")}`;
export const getProduct = (slug) => PRODUCTS.find((p) => p.slug === slug);
